import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  MenuItem,
  Select,
  TextField,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
} from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning';
}

export default function AdminReenvio(): JSX.Element {
  const [cpf, setCpf] = useState('');
  const [grupo, setGrupo] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingCPF, setLoadingCPF] = useState(false);
  const [loadingGrupo, setLoadingGrupo] = useState(false);
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleSair = () => {
    navigate('/');
  };

  const handleCloseSnackbar = () =>
    setSnackbar(prev => ({ ...prev, open: false }));

  const handleReenvioCPF = async () => {
    if (!cpf) {
      return setSnackbar({
        open: true,
        message: 'Informe um CPF.',
        severity: 'warning',
      });
    }
    if (!/^\d{11}$/.test(cpf)) {
      return setSnackbar({
        open: true,
        message: 'CPF inválido. Insira 11 números.',
        severity: 'warning',
      });
    }

    try {
      setLoadingCPF(true);
      //Verifica se o CPF existe no sistema
      const check = await axios.post(
        `http://localhost:3334/emails/send-mail-user?cpf=${cpf}`,
      );

      if (!check.data.exists) {
        return setSnackbar({
          open: true,
          message: 'CPF não encontrado no sistema.',
          severity: 'error',
        });
      }

      const res = await axios.post(
        `http://localhost:3334/emails/send-mail-user?cpf=${cpf}`,
      );

      setSnackbar({
        open: true,
        message: res.data.message || 'E-mail reenviado com sucesso!',
        severity: 'success',
      });
      setCpf('');
    } catch (error: any) {
      setSnackbar({
        open: true,
        message:
          error.response?.data?.error ||
          error.response?.data?.message ||
          'Erro ao reenviar e-mail.',
        severity: 'error',
      });
    } finally {
      setLoadingCPF(false);
    }
  };

  const handleReenvioGrupo = async () => {
    if (!grupo) {
      return setSnackbar({
        open: true,
        message: 'Selecione um grupo.',
        severity: 'warning',
      });
    }

    try {
      setLoadingGrupo(true);
      const res = await axios.post(
        `http://localhost:3334/send-mail-all-user?grupo=${grupo}`,
      );

      setSnackbar({
        open: true,
        message: res.data.message || 'E-mails reenviados para o grupo!',
        severity: 'success',
      });

      setGrupo('');
    } catch (error: any) {
      setSnackbar({
        open: true,
        message:
          error.response?.data?.error ||
          error.response?.data?.message ||
          'Erro ao reenviar e-mails para o grupo.',
        severity: 'error',
      });
    } finally {
      setLoadingGrupo(false);
    }
  };
  const LoadingButton = ({ onClick, loading, children }: any) => (
    <Button
      variant="contained"
      color="primary"
      fullWidth
      onClick={onClick}
      disabled={loading}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : children}
    </Button>
  );

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Box mt={10} p={5} border="1px solid #ccc" borderRadius={2} boxShadow={2}>
        <Typography variant="h5" gutterBottom>
          Reenvio de Boas-Vindas
        </Typography>

        <TextField
          label="CPF"
          variant="outlined"
          fullWidth
          value={cpf}
          onChange={e => setCpf(e.target.value)}
          margin="normal"
        />
        <Button
          aria-label="Reenviar e-mail por CPF"
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleReenvioCPF}
          disabled={loadingCPF}
          sx={{ mb: 4 }}
        >
          {loadingCPF ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'Reenviar email por CPF'
          )}
        </Button>

        <Select
          displayEmpty
          fullWidth
          value={grupo}
          onChange={e => setGrupo(e.target.value)}
          sx={{ mb: 2 }}
        >
          <MenuItem value="">Selecione um grupo</MenuItem>
          <MenuItem value="TODOS">Todos os associados</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleReenvioGrupo}
          disabled={loadingGrupo || grupo === ''}
        >
          {loadingGrupo ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'Reenviar para Grupo'
          )}
        </Button>
        <Box mt={5} p={0}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSair}
            disabled={loadingCPF || loadingGrupo}
            sx={{ mb: 4 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Sair'}
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
